<script setup lang="ts">
import {
  toRef,
} from 'vue';

import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import VForm from '@modules/forms/components/VForm/VForm.vue';
import { useI18nStore } from '@modules/i18n/store';
import VLocalizationTree from '@modules/translate-manager/components/VLocalizationTree/VLocalizationTree.vue';
import VTranslationLoader from '@modules/translate-manager/components/VTranslationLoader/VTranslationLoader.vue';
import { TRANSLATION_GROUP_TRANSLATE_MANAGER } from '@modules/translate-manager/constants';

import { useTranslateManagerPage } from './composables';

const fallbackLocale = toRef(useI18nStore(), 'fallbackLocale');

const {
  isTranslationsFetching,
  isBackendTranslationLoading,
  formSchema,
  formValues,
  selectedLanguage,
  frontendTranslations,
  backendTranslations,
  unitedTreeTranslations,
  onUploadLocalesFile,
  onSubmit,
} = useTranslateManagerPage();
</script>

<template>
  <VCard v-data-qa-auto-id="'TranslateManagerPage'"
    :title="$getTranslation(TRANSLATION_GROUP_TRANSLATE_MANAGER, 'TITLE')"
    type="form"
  >
    <div>
      <div class="mb-5">
        <VForm
          :schema="formSchema"
          submit-on-change
          @submit="onSubmit"
        />
      </div>

      <div class="text-xl">
        {{ $getTranslation(TRANSLATION_GROUP_TRANSLATE_MANAGER, 'FRONTEND') }}
      </div>
      <VLocalizationTree
        :items="frontendTranslations"
        :language="selectedLanguage"
        :fallback-language="fallbackLocale"
      />

      <div class="mt-5 text-xl">
        {{ $getTranslation(TRANSLATION_GROUP_TRANSLATE_MANAGER, 'BACKEND') }}
      </div>
      <VLoader
        :loading="isBackendTranslationLoading"
        mode="structural"
      >
        <VLocalizationTree
          :items="backendTranslations"
          :language="selectedLanguage"
          :fallback-language="fallbackLocale"
        />
      </VLoader>
    </div>
    <template #footer>
      <VTranslationLoader
        :language="selectedLanguage"
        :united-tree-translations="unitedTreeTranslations"
        :is-empty-locales-enabled="formValues.onlyEmpty"
        :is-locales-loading="isTranslationsFetching"
        @uploaded="onUploadLocalesFile"
      />
    </template>
  </VCard>
</template>
